export function myclassdecorator(constructor: Function) {
  console.log(`********************************** Class decorator called for ${constructor.name} *****************` );
  // You can add additional logic here if needed
}
// Ejemplo de factory decorator y decorator de metodo
export function LogExecutionTime(logLevel: string){
  return function(target: any,
                  propertyKey: string,
                  descriptor: PropertyDescriptor){
    // Referencia al metodo original
    const originalMethod = descriptor.value;
    // y lo machacamos con nuestro nuevo metodo
    descriptor.value = function(...args: any[]) {
      console.log(`[${logLevel}] Ejecutando ${propertyKey} con argumentos:`, args);
      const start = performance.now();
      // INvocamos el metodo original
      const restult = originalMethod.apply(this, args)
      const end = performance.now();
      console.log(`[${logLevel}] ${propertyKey} ejecutado en ${end - start} ms`);
      return restult; 
    }

    }
}